export const resultsColumns = {
    UPGRADES: () => {
        return [{ name: 'Cards', uid: 'name' }];
    },
    LEADERBOARD: () => {
        const max = window.innerWidth - 180;

        let columns = [
            { name: 'user', uid: 'authorAvatarUrl', maxWidth: 65, minWidth: 65, width: 65 },
            { name: 'Title and Commander(s)', uid: 'commanders', maxWidth: max, minWidth: 200, width: max },
            { name: '', uid: 'saltRating', maxWidth: 90, minWidth: 20, width: 120 },
        ];

        return columns;
    },
    LEADERBOARD_COMPACT: () => {
        return [
            { name: 'user', uid: 'authorAvatarUrl', flex: '0 0 50px', width: 50, minWidth: 50, maxWidth: 50 },
            {
                name: 'Title and Commander(s)',
                uid: 'commanders',
                flex: '1 1 0',
                width: 0,
                minWidth: 0,
                overflow: 'hidden',
            },
            { name: '', uid: 'saltRating', flex: '0 0 60px', width: 60, minWidth: 60, maxWidth: 60 },
        ];
    },
};
